import { inject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { ValidationMessageProvider } from "aurelia-validation";

@inject(I18N)
export class CustomValidationMessageProvider {
  constructor(private i18n: I18N) {}

  init(): void {
    let that = this;

    ValidationMessageProvider.prototype.getMessage = function (key) {
      const translation = that.i18n.tr(`validation.errormessages.${key}`);
      return this.parser.parse(translation);
    };
  }
}
